module.exports = __webpack_public_path__ + "assets/2ecf5aeb85b6924dcf4d4619251ab03c.ico";